import Fetch from "./Fetch";

import { API_BASIC_URL_SLOT_SERVICE } from "../config/constants";
import { handleError, handleCSVResponse } from "./ApiUtils";

export const downloadPOSBasicReport = (body) => {
  return Fetch.create(`${API_BASIC_URL_SLOT_SERVICE}/api/v1/report`, body).then(handleCSVResponse).catch(handleError);
};

export const downloadServiceConfigurationsReport = (body) => {
  return Fetch.create(`${API_BASIC_URL_SLOT_SERVICE}/api/v1/report`, body).then(handleCSVResponse).catch(handleError);
};
